import SelectBox from "components/Common/SelectBox"
import React from "react"
import { Col, Input, InputGroup, InputGroupText, Row, Table } from "reactstrap"

export default function Material({ data }) {
  const {
    fabricCompanyId,
    brand,
    bunch,
    fabricCompanyName,
    fabricId,
    fabricNumber,
    fabricYear,
    fabricSeasonId,
    fabricSeasonName,
    scale,
    clothWidth,
    fabricRank,
    color,
    outerMaterialComposition,
  } = data

  return (
    <>
      <p className="text-center">MATERIAL</p>
      <Table bordered>
        <tbody>
          <tr>
            <th style={{ width: 135 }}> 生地商社</th>
            <td>
              <SelectBox
                options={[]}
                value={{ label: fabricCompanyName, value: fabricCompanyId }}
                isDisabled={true}
              />
            </td>
          </tr>
          <tr>
            <th>生地メーカ</th>
            <td>
              <SelectBox
                options={[]}
                // todo: handle this later
                value={{
                  label: brand + " " + bunch,
                  value: brand + " " + bunch,
                }}
                isDisabled={true}
              />
            </td>
          </tr>
          <tr>
            <th>年度・シーズン</th>
            <td>
              <Row>
                <Col>
                  <SelectBox
                    options={[]}
                    value={{
                      label: fabricYear,
                      value: fabricYear,
                    }}
                    isDisabled={true}
                  />
                </Col>
                <Col>
                  <SelectBox
                    options={[]}
                    value={{
                      label: fabricSeasonName,
                      value: fabricSeasonId,
                    }}
                    isDisabled={true}
                  />
                </Col>
              </Row>
            </td>
          </tr>
          <tr>
            <th>Art No.・用尺</th>
            <td>
              <Row>
                <Col>
                  <SelectBox
                    options={[{}]}
                    value={{ value: fabricId, label: fabricNumber }}
                    onChange={v => handleInput({ val: v, type: "fabricId" })}
                    isDisabled={true}
                  />
                </Col>

                <Col>
                  <InputGroup>
                    <Input type="text" value={scale} readOnly disabled />
                    <InputGroupText>M</InputGroupText>
                  </InputGroup>
                </Col>
              </Row>
            </td>
          </tr>
          <tr>
            <th>生地巾・ランク</th>

            <td>
              <InputGroup>
                <Input type="text" value={clothWidth} readOnly disabled />
                <Input type="text" value={fabricRank} readOnly disabled />
              </InputGroup>
            </td>
          </tr>
          <tr>
            <th>カラー</th>
            <td>
              <Input type="text" value={color} readOnly disabled />
            </td>
          </tr>
          <tr>
            <th>表地組成</th>
            <td>
              <Input
                type="text"
                value={outerMaterialComposition}
                readOnly
                disabled
              />
            </td>
          </tr>
        </tbody>
      </Table>
    </>
  )
}
